// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"277a77ca","806":"b47cffdc"}[chunkId] + ".chunk.js";
};